import { Routes } from '@angular/router';
import { AppRoutes, blockWebVersionGuard, GamesRoutes } from '@core';
import { GameFinishedComponent, LineupsComponent, MyGameDetailsComponent, SharedGameComponent } from './components';
import { sharedGameResolver } from './application/resolvers';
import { isAuthedGuard } from '@auth';

export const GamesRouting: Routes = [
  {
    path: GamesRoutes.ROOT,
    redirectTo: `/${AppRoutes.MY_GAMES}`,
    pathMatch: 'full'
  },
  {
    path: `${GamesRoutes.DETAILS}/:id`,
    component: MyGameDetailsComponent,
    canActivate: [blockWebVersionGuard]
  },
  {
    path: GamesRoutes.FUTURE,
    redirectTo: `/${AppRoutes.MY_GAMES}`,
    pathMatch: 'full'
  },
  {
    path: GamesRoutes.PAST,
    redirectTo: `/${AppRoutes.MY_GAMES}`,
    pathMatch: 'full'
  },
  {
    path: `${GamesRoutes.SHARED}/:id`,
    component: SharedGameComponent,
    resolve: { sharedGameResolver }
  },
  {
    path: `${GamesRoutes.GAME_FINISHED}/:id`,
    component: GameFinishedComponent,
    canActivate: [blockWebVersionGuard, isAuthedGuard]
  },
  {
    path: `${GamesRoutes.LINEUPS}/:id`,
    component: LineupsComponent,
    canActivate: [blockWebVersionGuard, isAuthedGuard]
  }
];
